/*!
 * Dalafisk – review band
 * ------------------------------------------------------------------
 * One job: make the design's "Skriv ett omdöme" button, which lives in the
 * summary card on the LEFT, open Judge.me's review form, which lives in the
 * widget on the RIGHT.
 *
 * WHY A PROXY AND NOT OUR OWN BUTTON. The review form is Judge.me's: it posts
 * to their API, carries their validation, their photo upload and their consent
 * copy. Reimplementing any of that to match a button position would be a
 * second, worse review form. So this clicks theirs.
 *
 * WHY THE BUTTON STARTS HIDDEN. Judge.me's widget is injected after load. A
 * button rendered up front would be clickable during the gap and do nothing,
 * and if the app is ever removed it would sit there dead forever. It is shown
 * only once its target has actually been found, so it cannot outlive it.
 */
(function () {
  'use strict';

  if (window.__dalafiskReviews) return;
  window.__dalafiskReviews = true;

  /* `data-testid` on the current ("revamp") widget; `.jdgm-write-rev-link` on
     the older one. Both are checked so this does not break on whichever
     version the shop is serving. */
  var TARGETS = '[data-testid="write-review-button"], .jdgm-write-rev-link';

  function wire(scope) {
    var proxy = scope.querySelector('[data-dalafisk-write-review]');
    if (!proxy || proxy.dataset.dalafiskWired) return false;

    var target = scope.querySelector(TARGETS);
    if (!target) return false;

    proxy.dataset.dalafiskWired = '1';
    proxy.hidden = false;
    proxy.addEventListener('click', function () {
      /* Re-read on every click: Judge.me re-renders its widget when the list is
         sorted or paged, which replaces the node captured above. */
      var live = scope.querySelector(TARGETS);
      if (live) live.click();
    });
    return true;
  }

  function init() {
    var scope = document.querySelector('.dalafisk-product-reviews');
    if (!scope) return;
    if (wire(scope)) return;

    /* Judge.me injects asynchronously, so watch until it lands. Give up after
       20s rather than observing the document for the life of the page — by then
       the app is not coming, and the button stays hidden, which is correct. */
    var observer = new MutationObserver(function () {
      if (wire(scope)) observer.disconnect();
    });
    observer.observe(scope, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
